/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Showcase_Featuredgamestitle2Inputs */

const id_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game Unggulan`)
};

const ms_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan Pilihan`)
};

const da_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fremhævede Spil`)
};

const de_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorgestellte Spiele`)
};

const en_us2_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured Games`)
};

const es_es2_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos destacados`)
};

const es_mx2_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos destacados`)
};

const fil_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Itinatampok na Laro`)
};

const fr_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeux en vedette`)
};

const it_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giochi in evidenza`)
};

const hu_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiemelt játékok`)
};

const nl_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitgelichte games`)
};

const no_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fremhevede spill`)
};

const pl_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyróżnione gry`)
};

const pt_br2_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos em destaque`)
};

const pt_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos em destaque`)
};

const ro_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jocuri prezentate`)
};

const fi_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esitellyt pelit`)
};

const sv_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utvalda spel`)
};

const vi_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game nổi bật`)
};

const tr_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öne Çıkan Oyunlar`)
};

const cs_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejlepší hry`)
};

const bg_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Препоръчани игри`)
};

const ru_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рекомендуемые игры`)
};

const uk_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рекомендовані ігри`)
};

const ar_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الألعاب المميزة`)
};

const hi_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ीचर्ड गेम`)
};

const th_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมเด่น`)
};

const ja_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注目のゲーム`)
};

const zh_cn2_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精选游戏`)
};

const zh_hant1_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精選遊戲`)
};

const ko_profile_showcase_featuredgamestitle2 = /** @type {(inputs: Profile_Showcase_Featuredgamestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추천 게임`)
};

/**
* | output |
* | --- |
* | "Featured Games" |
*
* @param {Profile_Showcase_Featuredgamestitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_showcase_featuredgamestitle2 = /** @type {((inputs?: Profile_Showcase_Featuredgamestitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Showcase_Featuredgamestitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "ms") return ms_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "da") return da_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "de") return de_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "en-US") return en_us2_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "es-ES") return es_es2_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "es-MX") return es_mx2_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "fil") return fil_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "fr") return fr_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "it") return it_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "hu") return hu_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "nl") return nl_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "no") return no_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "pl") return pl_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "pt") return pt_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "ro") return ro_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "fi") return fi_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "sv") return sv_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "vi") return vi_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "tr") return tr_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "cs") return cs_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "bg") return bg_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "ru") return ru_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "uk") return uk_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "ar") return ar_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "hi") return hi_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "th") return th_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "ja") return ja_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_showcase_featuredgamestitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_showcase_featuredgamestitle2(inputs)
	return ko_profile_showcase_featuredgamestitle2(inputs)
});
export { profile_showcase_featuredgamestitle2 as "profile.showcase.featuredGamesTitle" }